import React from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Button, Col, Container, Row, TextInput, Icon } from 'react-materialize';
import Modal from './modal';

class ModalWarehouseAgents extends React.Component {
  constructor(props) {
    super(props);

    const user = JSON.parse(localStorage.getItem('user')) || {};
    const login = String(user?.username || user?.user || user?.name || '').toLowerCase();

    let forcedSite = null;
    if (login === 'jdomingu') forcedSite = '3000';
    if (login === 'omartine') forcedSite = '3100';

    const site = forcedSite || this.getUserSite(user) || '3000';

    this.state = {
      user,
      site: String(site),
      q: '',
      includeInactive: false,

      loading: false,
      rows: [],

      formOpen: false,
      editingId: null,
      form: {
        id: '',
        username: '',
        name: '',
        site: String(site),
        isActive: 1,
      },
    };
  }

  getUserLogin = () => {
    const u = this.state?.user || {};
    return String(u.username || u.user || u.name || '').toLowerCase();
  };

  getManagerScopeByLogin = (login = '') => {
    const clean = String(login || '').trim().toLowerCase();

    if (clean === 'jdomingu') {
      return { login: clean, site: '3000', siteLabel: '3000 (MTY)' };
    }

    if (clean === 'omartine') {
      return { login: clean, site: '3100', siteLabel: '3100 (CDMX)' };
    }

    return null;
  };

  getManagerScope = () => {
    return this.getManagerScopeByLogin(this.getUserLogin());
  };

  isWarehouseManager = () => !!this.getManagerScope();

  getForcedSite = () => {
    const scope = this.getManagerScope();
    return scope?.site || null;
  };

  authHeaders = () => {
    const login = this.getUserLogin();
    return login ? { 'x-user-login': login } : {};
  };

  getUserSite = (u) => {
    const raw =
      u?.site ||
      u?.siteId ||
      u?.site_id ||
      u?.pickup_branch ||
      u?.branch ||
      u?.store ||
      u?.sucursal ||
      '';
    const s = String(raw || '').trim();
    const m = s.match(/\b(3000|3100)\b/);
    return m ? m[1] : (s || null);
  };

  stripAccents = (s = '') => {
    return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  normalizeForTokens = (s = '') => {
    return this.stripAccents(String(s))
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  stopWords = new Set(['de', 'del', 'la', 'las', 'los', 'y', 'e', 'da', 'do', 'dos', 'das']);

  pickNameWords = (fullName = '') => {
    const raw = this.normalizeForTokens(fullName);
    const parts = raw.split(' ').filter(Boolean);
    const words = parts.filter(w => /[a-z]/.test(w) && !this.stopWords.has(w));
    return { raw, parts, words };
  };

  getAlmacenNumber = (fullName = '') => {
    const raw = this.normalizeForTokens(fullName);
    const m = raw.match(/\balmacen\s*([0-9]+)\b/);
    if (m && m[1]) return String(parseInt(m[1], 10));
    return null;
  };

  makeUsernameBase = (fullName = '') => {
    const { raw, words } = this.pickNameWords(fullName);
    if (!raw) return '';

    const n = this.getAlmacenNumber(fullName);
    if (n) return `almacen${n}`;

    if (!words.length) return '';
    const first = words[0];

    let surname = '';
    if (words.length >= 3) surname = words[words.length - 2];
    else if (words.length >= 2) surname = words[words.length - 1];
    else surname = words[0];

    const base = (first[0] || '') + surname;
    return base.replace(/\s/g, '');
  };

  makeIdBase = (fullName = '', site = '3000') => {
    const n = this.getAlmacenNumber(fullName);
    if (n) {
      const id = `VAL${n}`.toUpperCase();
      return id.slice(0, 4);
    }

    const { words } = this.pickNameWords(fullName);
    if (!words.length) return '';

    const first = words[0];
    const firstInitial = (first[0] || 'X').toUpperCase();
    const secondLetter = (first[1] || 'X').toUpperCase();

    let surname = '';
    if (words.length >= 3) surname = words[words.length - 2];
    else if (words.length >= 2) surname = words[words.length - 1];
    else surname = words[0];

    const surnameInitial = (surname[0] || 'X').toUpperCase();

    const prefix = 'V';
    return `${prefix}${firstInitial}${secondLetter}${surnameInitial}`.slice(0, 4);
  };

  makeUniqueUsername = (base, existingSet) => {
    if (!base) return '';
    let candidate = base;
    let i = 1;
    while (existingSet.has(candidate)) {
      i += 1;
      candidate = `${base}${i}`.slice(0, 20);
    }
    return candidate;
  };

  makeUniqueId = (base4, existingSet) => {
    if (!base4) return '';
    let candidate = base4.toUpperCase().slice(0, 4);
    if (!existingSet.has(candidate)) return candidate;

    const pre = candidate.slice(0, 3);
    const pool = '23456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let k = 0; k < pool.length; k++) {
      const c = `${pre}${pool[k]}`;
      if (!existingSet.has(c)) return c;
    }

    return `${pre}Z`;
  };

  deriveIdsFromName = (name, site) => {
    const rows = Array.isArray(this.state.rows) ? this.state.rows : [];
    const usernames = new Set(rows.map(r => String(r.username || '').toLowerCase()).filter(Boolean));
    const ids = new Set(rows.map(r => String(r.id || '').toUpperCase()).filter(Boolean));

    const baseUser = this.makeUsernameBase(name);
    const username = this.makeUniqueUsername(baseUser, usernames);

    const baseId = this.makeIdBase(name, site);
    const id = this.makeUniqueId(baseId, ids);

    return { id, username };
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.fetchAgents();
    }

    if (
      this.props.isOpen &&
      (
        prevState.site !== this.state.site ||
        prevState.q !== this.state.q ||
        prevState.includeInactive !== this.state.includeInactive
      )
    ) {
      clearTimeout(this._t);
      this._t = setTimeout(() => this.fetchAgents(), 250);
    }
  }

  componentWillUnmount() {
    clearTimeout(this._t);
  }

  fetchAgents = async () => {
    try {
      const site = String(this.getForcedSite() || this.state.site || '').trim();
      if (!site) return;

      this.setState({ loading: true });

      const params = {
        site,
        q: String(this.state.q || '').trim(),
      };

      if (this.isWarehouseManager() && this.state.includeInactive) {
        params.include_inactive = 1;
      }

      const { data } = await axios.get('/api/warehouse-agents', {
        params,
        headers: this.authHeaders(),
      });

      const rows = Array.isArray(data) ? data : (data?.data || []);
      this.setState({ rows, loading: false });
    } catch (e) {
      console.error('[ModalWarehouseAgents] fetchAgents error', e);
      this.setState({ loading: false });
      Swal.fire('Error', 'No se pudo cargar la lista de agentes.', 'error');
    }
  };

  openNew = () => {
    const site = String(this.getForcedSite() || this.state.site || '3000');

    this.setState({
      formOpen: true,
      editingId: null,
      form: { id: '', username: '', name: '', site, isActive: 1 },
    });
  };

  openEdit = (row) => {
    this.setState({
      formOpen: true,
      editingId: String(row.id || '').toUpperCase(),
      form: {
        id: String(row.id || '').toUpperCase(),
        username: String(row.username || '').toLowerCase(),
        name: String(row.name || ''),
        site: String(this.getForcedSite() || row.site || this.state.site || '3000'),
        isActive: Number(row.isActive) ? 1 : 0,
      },
    });
  };

  closeForm = () => this.setState({ formOpen: false, editingId: null });

  setFormField = (key, value) => {
    this.setState((prev) => ({
      form: { ...(prev.form || {}), [key]: value },
    }));
  };

  onChangeName = (val) => {
    const name = String(val || '');
    const editing = !!this.state.editingId;

    if (editing) {
      this.setState(prev => ({ form: { ...(prev.form || {}), name } }));
      return;
    }

    const site = String(this.getForcedSite() || this.state.form?.site || this.state.site || '3000');
    const { id, username } = this.deriveIdsFromName(name, site);

    this.setState(prev => ({
      form: { ...(prev.form || {}), name, id, username }
    }));
  };

  onChangeSite = (val) => {
    const forcedSite = this.getForcedSite();
    const site = String(forcedSite || val || '3000');
    const editing = !!this.state.editingId;

    if (editing) {
      this.setState(prev => ({ form: { ...(prev.form || {}), site } }));
      return;
    }
    const name = String(this.state.form?.name || '');
    const { id, username } = this.deriveIdsFromName(name, site);

    this.setState(prev => ({
      form: { ...(prev.form || {}), site, id, username }
    }));
  };

  validateForm = () => {
    const f = this.state.form || {};
    const name = String(f.name || '').trim();
    const site = String(this.getForcedSite() || f.site || '').trim();

    if (!name) return 'Falta nombre';
    if (site !== '3000' && site !== '3100') return 'Site inválido (3000|3100)';

    if (!this.state.editingId) {
      const id = String(f.id || '').trim().toUpperCase();
      const username = String(f.username || '').trim().toLowerCase();

      if (!id) return 'No se pudo generar el ID automáticamente';
      if (!username) return 'No se pudo generar el username automáticamente';
    }

    return null;
  };

  save = async () => {
    if (!this.isWarehouseManager()) {
      Swal.fire('No autorizado', 'No tienes permisos para modificar agentes.', 'warning');
      return;
    }

    const err = this.validateForm();
    if (err) {
      Swal.fire('Validación', err, 'warning');
      return;
    }

    const f = this.state.form || {};
    const site = String(this.getForcedSite() || f.site || '3000');
    let id = String(f.id || '').trim().toUpperCase();
    let username = String(f.username || '').trim().toLowerCase();

    if (!this.state.editingId) {
      const d = this.deriveIdsFromName(String(f.name || ''), site);
      id = id || d.id;
      username = username || d.username;
    }

    const payload = {
      id,
      username,
      name: String(f.name || '').trim(),
      site: parseInt(site, 10),
      isActive: Number(f.isActive) ? 1 : 0,
    };

    try {
      this.setState({ loading: true });

      if (this.state.editingId) {
        await axios.put(`/api/warehouse-agents/${encodeURIComponent(payload.id)}`, payload, {
          headers: this.authHeaders(),
        });
      } else {
        await axios.post('/api/warehouse-agents', payload, {
          headers: this.authHeaders(),
        });
      }

      Swal.fire('Listo', 'Agente guardado', 'success');
      this.closeForm();
      await this.fetchAgents();
    } catch (e) {
      console.error('[ModalWarehouseAgents] save error', e);
      Swal.fire('Error', 'No se pudo guardar el agente.', 'error');
    } finally {
      this.setState({ loading: false });
    }
  };

  toggleActive = async (row, nextActive) => {
    if (!this.isWarehouseManager()) return;

    const id = String(row?.id || '').toUpperCase();
    if (!id) return;

    try {
      this.setState({ loading: true });
      await axios.put(
        `/api/warehouse-agents/${encodeURIComponent(id)}`,
        { isActive: nextActive ? 1 : 0 },
        { headers: this.authHeaders() }
      );
      await this.fetchAgents();
    } catch (e) {
      console.error('[ModalWarehouseAgents] toggleActive error', e);
      Swal.fire('Error', 'No se pudo actualizar el estatus del agente.', 'error');
    } finally {
      this.setState({ loading: false });
    }
  };


  hardDelete = async (row) => {
    if (!this.isWarehouseManager()) return;

    const id = String(row?.id || '').toUpperCase();
    if (!id) return;

    const r = await Swal.fire({
      icon: 'error',
      title: 'Eliminar DEFINITIVO',
      html: `Esto borra el agente de la tabla.<br/>¿Seguro?`,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (!r.isConfirmed) return;

    try {
      this.setState({ loading: true });
      await axios.delete(`/api/warehouse-agents/${encodeURIComponent(id)}?hard=1`, {
        headers: this.authHeaders(),
      });
      await this.fetchAgents();
    } catch (e) {
      console.error('[ModalWarehouseAgents] hardDelete error', e);
      Swal.fire('Error', 'No se pudo eliminar el agente.', 'error');
    } finally {
      this.setState({ loading: false });
    }
  };

  renderForm() {
    if (!this.state.formOpen) return null;

    const f = this.state.form || {};
    const editing = !!this.state.editingId;
    const scope = this.getManagerScope();

    return (
      <div style={{ background: '#f6f7f8', padding: 12, borderRadius: 10, marginTop: 12 }}>
        <Row style={{ marginBottom: 0 }}>
          <Col s={12}>
            <h6 style={{ fontWeight: 800, margin: '6px 0 12px' }}>
              {editing ? 'Editar agente' : 'Nuevo agente'}
            </h6>
          </Col>

          <Col s={12} m={8}>
            <TextInput
              label="Nombre"
              value={String(f.name || '')}
              onChange={(e) => this.onChangeName(e.target.value)}
            />
          </Col>

          <Col s={12} m={4}>
            <label style={{ fontSize: 12, color: '#666' }}>Site</label>
            <div
              style={{
                height: 42,
                display: 'flex',
                alignItems: 'center',
                padding: '0 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                background: '#f5f5f5'
              }}
            >
              {scope?.siteLabel || (String(f.site || '3000') === '3100' ? '3100 (CDMX)' : '3000 (MTY)')}
            </div>
          </Col>

          <Col s={12} style={{ marginTop: 6 }}>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', color: '#666', fontSize: 12 }}>
              <div>
                <b>Usuario generado:</b> {String(f.username || '') || <span style={{ color: '#999' }}>—</span>}
              </div>
              <div>
                <b>ID generado:</b> {String(f.id || '') || <span style={{ color: '#999' }}>—</span>}
              </div>
              {editing && (
                <div style={{ color: '#999' }}>
                  (En edición no se regeneran)
                </div>
              )}
            </div>
          </Col>

          <Col s={12} style={{ marginTop: 10, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <Button className="green" onClick={this.save}>
              <Icon left>check</Icon>Guardar
            </Button>

            <Button className="grey" onClick={this.closeForm}>
              <Icon left>close</Icon>Cancelar
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  renderTable() {
    const rows = Array.isArray(this.state.rows) ? this.state.rows : [];

    return (
      <div style={{ overflowX: 'auto', marginTop: 14 }}>
        <table className="striped">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Site</th>
              <th>Activo</th>
              <th style={{ minWidth: 220 }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const id = String(r.id || '').toUpperCase();
              const active = Number(r.isActive) ? 1 : 0;

              return (
                <tr key={id || `${r.name}-${r.site}`}>
                  <td>{String(r.name || '')}</td>
                  <td>{String(r.site || '')}</td>
                  <td>{active ? 'Sí' : 'No'}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      <Button small className="grey darken-2" onClick={() => this.openEdit(r)}>
                        <Icon left>edit</Icon>Editar
                      </Button>

                      {active ? (
                        <Button small className="orange" onClick={() => this.toggleActive(r, false)}>
                          <Icon left>pause</Icon>Desactivar
                        </Button>
                      ) : (
                        <Button small className="green" onClick={() => this.toggleActive(r, true)}>
                          <Icon left>play_arrow</Icon>Activar
                        </Button>
                      )}


                      <Button small className="black" onClick={() => this.hardDelete(r)}>
                        <Icon left>delete_forever</Icon>Eliminar
                      </Button>
                    </div>
                  </td>
                </tr>
              );
            })}

            {!rows.length && (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', padding: 16 }}>
                  No hay agentes para estos filtros.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const scope = this.getManagerScope();

    if (this.props.isOpen && !scope) {
      return (
        <Modal isOpen={this.props.isOpen} onClose={this.props.onClose}>
          <Container>
            <Row>
              <Col s={12}>
                <h5 style={{ fontWeight: 900 }}>Agentes de Almacén</h5>
                <p>No autorizado.</p>
                <Button className="grey" onClick={this.props.onClose}>
                  Cerrar
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal>
      );
    }

    return (
      <Modal isOpen={this.props.isOpen} onClose={this.props.onClose}>
        <Container className="remove-padding">
          <Row>
            <Col s={12}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                <h5 style={{ fontWeight: 900, margin: 0 }}>Agentes de Almacén</h5>

                <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                  <div style={{ minWidth: 160 }}>
                    <label style={{ fontSize: 12, color: '#666' }}>Site</label>
                    <div
                      style={{
                        height: 42,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 12px',
                        border: '1px solid #ccc',
                        borderRadius: 4,
                        background: '#f5f5f5'
                      }}
                    >
                      {scope?.siteLabel || (this.state.site === '3100' ? '3100 (CDMX)' : '3000 (MTY)')}
                    </div>
                  </div>

                  <div style={{ minWidth: 240 }}>
                    <TextInput
                      label="Buscar"
                      value={this.state.q}
                      onChange={(e) => this.setState({ q: e.target.value })}
                    />
                  </div>


                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 10 }}>
                    <input
                      type="checkbox"
                      checked={!!this.state.includeInactive}
                      onChange={(e) => this.setState({ includeInactive: e.target.checked })}
                    />
                    <span>Ver inactivos</span>
                  </label>

                  <Button small className="blue" onClick={this.fetchAgents}>
                    <Icon left>refresh</Icon>Actualizar
                  </Button>

                  <Button small className="green" onClick={this.openNew}>
                    <Icon left>person_add</Icon>Nuevo
                  </Button>

                  <Button small className="grey" onClick={this.props.onClose}>
                    <Icon left>close</Icon>Cerrar
                  </Button>
                </div>
              </div>

              {this.state.loading && (
                <div style={{ marginTop: 12, padding: 10, background: '#fff3cd', borderRadius: 10 }}>
                  <b>Cargando...</b>
                </div>
              )}

              {this.renderForm()}
              {this.renderTable()}
            </Col>
          </Row>
        </Container>
      </Modal>
    );
  }
}

export default ModalWarehouseAgents;
